import createDataState from './defaultState'

export default {
  clearSessionData(state) {
    Object.assign(state, createDataState())
  },
  setNumMerchants(state, { numMerchants }) {
    state.numMerchants = numMerchants
  },
  setCurrentMerchant(state, { merchant }) {
    state.currentMerchant = merchant
    state.group = null
  },
  setMerchantLoading(state, { loading }) {
    state.merchantLoading = loading
  },
  setMerchantPage(state, { merchants }) {
    state.merchants = merchants
    state.merchantLoading = false
  },
  setNumCustomers(state, { numCustomers }) {
    state.numCustomers = numCustomers
  },
  setCustomerLoading(state, loading) {
    state.customerLoading = loading
  },
  setCustomerPage(state, { customers }) {
    state.customers = customers
    state.customerLoading = false
  },
  setRecentPaymentLoading(state, loading) {
    state.recentPaymentLoading = loading
  },
  setNumAccounts(state, { numAccounts }) {
    state.numAccounts = numAccounts
  },
  setAccountLoading(state, { loading }) {
    state.accountLoading = loading
  },
  setAccountPage(state, { accounts }) {
    state.accounts = accounts
    state.accountLoading = false
  },
  setPageTitle(state, pageTitle) {
    state.pageTitle = pageTitle
  },
  setCSVData(state, data) {
    state.csvData = data
  },
  setRefreshComplete(state, isRefreshComplete) {
    state.isRefreshComplete = isRefreshComplete
  },
  setStartupLoadError(state, error) {
    state.startupLoadError = error
  },
  setAccountPromises(state, promises) {
    state.accountPromises = promises
  },
  setAccountPromisesLoading(state, isLoading) {
    state.accountPromisesLoading = isLoading
  },
  clearCurrentCustomer(state) {
    state.currentCustomer = {}
  },
  setCurrentCustomer(state, customer) {
    state.currentCustomer = customer
  },
  clearCurrentAccount(state) {
    state.currentAccount = {}
  },
  setCurrentAccount(state, account) {
    state.currentAccount = account
  },
  setLocations(state, locations) {
    state.locations = locations
  },
  setCurrentLocation(state, location) {
    state.currentLocation = location
  },
  setSelectedLocation(state, location) {
    state.selectedLocation = location
  },
  setAccountTags(state, tags) {
    const withText =
      tags?.map(tag => {
        tag['text'] = tag.name

        return tag
      }) ?? []

    state.accountTags = withText
  },
  setGroup(state, group) {
    state.group = group
  },
  clearGroup(state) {
    state.group = null
  },
  setUsers(state, users) {
    state.users = users
  },
  setFailedActions(state, actions) {
    state.failedActions = actions
  },
  setReceiptModalVisibility(state, isOpen) {
    if (!isOpen) {
      // When closing the modal we should clear the invoice
      state.currentPayment = null
    }
    state.receiptModalOpen = isOpen
  },
  setCurrentPayment(state, payment) {
    state.currentPayment = payment
  },
  setRoleLoading(state, isLoading) {
    state.roleLoading = isLoading
  },
  setRole(state, role) {
    state.role = role
  },
  setDashboardDateRange(state, dateRange) {
    state.dashboardDateRange = dateRange
  },
  setIsSideNavOpen(state, isOpen) {
    state.isSideNavOpen = isOpen
  },
  setIsReportsFlyoutOpen(state, isOpen) {
    state.isReportsFlyoutOpen = isOpen
  },
  setStarredReports(state, keys) {
    state.starredReports = keys
  },
  setUiPreferences(state, preferences) {
    state.uiPreferences = preferences
  },
  // Logout routes to Login without reloading the page, so only the authstore is
  // reset. These two are per-user, and the next user in the tab would see the
  // previous one's starred pills and save over their bucket.
  resetUserPreferences(state) {
    state.starredReports = []
    state.uiPreferences = {}
  },
  setAiBatchConfigs(state, configs) {
    state.aiBatchConfigs = configs
  },
  setAiBatchConfigsCount(state, count) {
    state.aiBatchConfigsCount = count
  },
  setAiBatchConfigsLoading(state, isLoading) {
    state.aiBatchConfigsLoading = isLoading
  },
  setAiCallerAgents(state, agents) {
    state.aiCallerAgents = agents
  },
  setAiCallerAgentsLoading(state, isLoading) {
    state.aiCallerAgentsLoading = isLoading
  },
  setAiCallerBatches(state, batches) {
    state.aiCallerBatches = Array.isArray(batches) ? batches : []
  },
  setAiCallerBatchesCount(state, count) {
    state.aiCallerBatchesCount = typeof count === 'number' ? count : 0
  },
  setAiCallerBatchesLoading(state, isLoading) {
    state.aiCallerBatchesLoading = isLoading
  },
  mergeAiCallerBatchProgress(state, updates) {
    if (!Array.isArray(updates) || updates.length === 0) {
      return
    }

    const updatesById = updates.reduce((map, update) => {
      if (update?.id == null) {
        return map
      }
      map.set(update.id, update)

      return map
    }, new Map())

    state.aiCallerBatches = state.aiCallerBatches.map(batch => {
      if (!batch || !updatesById.has(batch.id)) {
        return batch
      }

      const progressUpdate = updatesById.get(batch.id)

      return {
        ...batch,
        status:
          typeof progressUpdate.status === 'string'
            ? progressUpdate.status
            : batch.status,
        call_count:
          typeof progressUpdate.call_count === 'number'
            ? progressUpdate.call_count
            : batch.call_count,
        expected_call_count:
          typeof progressUpdate.expected_call_count === 'number'
            ? progressUpdate.expected_call_count
            : batch.expected_call_count,
        progress_percent:
          typeof progressUpdate.progress_percent === 'number'
            ? progressUpdate.progress_percent
            : batch.progress_percent,
        dispatched_count:
          typeof progressUpdate.dispatched_count === 'number'
            ? progressUpdate.dispatched_count
            : batch.dispatched_count,
        failed_count:
          typeof progressUpdate.failed_count === 'number'
            ? progressUpdate.failed_count
            : batch.failed_count,
        dispatch_errors: Array.isArray(progressUpdate.dispatch_errors)
          ? progressUpdate.dispatch_errors
          : batch.dispatch_errors
      }
    })
  }
}
